import { Box, Button, Circle, Input, Progress, Radio, RadioGroup, Stack, Text, useToast } from "@chakra-ui/react"
import { useRef, useState } from "react"
import { ReactComponent as PlusIcon } from '../../svg/plus.svg'
import { ReactComponent as MinusIcon } from '../../svg/minus.svg'
import { ReactComponent as SaveIcon } from '../../svg/save.svg'
import Question from "./Question"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { addOneQuestionAndChoices, deleteQuestion, loadQuizQuestions, submitQuestionAndChoices } from "../../redux/api_calls/apiCalls"
import { useHistory } from "react-router-dom"
import { resetEdit, resetFormStatus, resetLoadedQuestions, resetQuestionFormStatus } from "../../redux/actions/actions"
import AlertMessage from "../common/AlertMessage"

export default function FormPartTwo({ backClickHandler }) {
    const [addQuestionError, setAddQuestionError] = useState(null)
    const [questions, setQuestions] = useState([])
    const [radioButton, setRadioButton] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [hoverPosition, setHoverPosition] = useState(null)
    const [questionTemplateEmpty, setQuestionTemplateEmpty] = useState(true)
    const [alertIsOpen, setAlertIsOpen] = useState(false)
    const [choices, setChoices] = useState([
        { is_right_choice: 'N', choice: '', status: 'Y' },
        { is_right_choice: 'N', choice: '', status: 'Y' },
        { is_right_choice: 'N', choice: '', status: 'Y' },
        { is_right_choice: 'N', choice: '', status: 'Y' }
    ])
    const questionRef = useRef()
    const editState = useSelector(state => state.editState)
    const formStatus = useSelector(state => state.questionFormStatus)
    const questionState = useSelector(state => state.questionsState)
    const dispatch = useDispatch()
    const toast = useToast()
    const history = useHistory()

    const removeOptionHandler = (id) => {
        let newChoices = [...choices]
        newChoices.splice(id, 1)
        setChoices(newChoices)
    }

    const addOptionHandler = (id) => {
        let newChoices = choices.slice(0, id + 1).concat([{ is_right_choice: 'N', choice: '' }, ...choices.slice(id + 1)])
        setChoices(newChoices)
    }

    const checkForEmptyQuestionTemplate = () => {
        let flag = false
        if (questionRef.current.value.trim().length === 0) {
            flag = true
        }
        else {
            flag = false
        }
        if (flag && choices.every(choice => choice.choice.trim().length === 0)) {
            flag = true
        }
        else {
            flag = false
        }
        setQuestionTemplateEmpty(flag)
    }

    const changeHandler = (e, id) => {
        let newChoices = [...choices]
        newChoices[id].choice = e.target.value
        if (newChoices.every(choice => choice.choice.trim().length !== 0)) {
            setQuestionTemplateEmpty(false)
        }
        setChoices(newChoices)
        checkForEmptyQuestionTemplate()
    }

    const questionChangeHandler = () => {
        if (questionRef.current.value.trim().length !== 0) {
            setQuestionTemplateEmpty(false)
        }
        checkForEmptyQuestionTemplate()
        setAddQuestionError(null)
    }

    const validateNewQuestion = () => {
        let error = null
        if (questionRef.current.value.trim().length === 0) {
            error = 'Question Field cannot be empty!'
        }
        else if (choices.some(option => option.choice.length === 0)) {
            error = 'One or more option fields are empty!'
        }

        else if (choices.length < 2) {
            error = 'Atleast 2 choices should be provided!'
        }
        else if (!radioButton) {
            error = 'Correct answer is not provided!'
        }
        else if (questions.some(question => question.question.question_title === questionRef.current.value.trim())) {
            error = 'Question already exists!'
        }
        if (error) {
            setAddQuestionError(error)
            return false
        }
        else {
            return true
        }
    }

    const resetQuestionTemplate = () => {
        setChoices([
            { is_right_choice: 'N', choice: '', status: 'Y' },
            { is_right_choice: 'N', choice: '', status: 'Y' },
            { is_right_choice: 'N', choice: '', status: 'Y' },
            { is_right_choice: 'N', choice: '', status: 'Y' }
        ])
        setRadioButton(null)
        setAddQuestionError(null)
        setQuestionTemplateEmpty(true)
        questionRef.current.value = ''
    }

    const addQuestionHandler = async () => {
        if (!validateNewQuestion()) {
            return
        }
        else {
            let allQuestions = [...questions]
            let currentChoices = choices.map(option => option.choice === radioButton ? { ...option, is_right_choice: 'Y' } : option)
            allQuestions.push({ question: { question_title: questionRef.current.value.trim(), status: 'Y' }, choices: currentChoices })
            if (editState.flag) {
                setIsLoading(true)
                let questionObject = {
                    quiz_id: editState.id,
                    formData: [{ question: { question_title: questionRef.current.value.trim(), status: 'Y' }, choices: currentChoices }]
                }
                try {
                    await addOneQuestionAndChoices(questionObject)
                    setIsLoading(false)
                    getQuestions()
                }
                catch (error) {
                    setAddQuestionError(error.message)
                    setIsLoading(false)
                    return
                }
            }
            else {
                setQuestions(allQuestions)
                localStorage.setItem('questions', JSON.stringify(allQuestions))
            }
            resetQuestionTemplate()
        }
    }

    const deleteHandler = (id) => {
        let currentQuestions = questions.filter(question => question.question.id !== id)
        if (editState.flag) {
            dispatch(deleteQuestion(currentQuestions, id))
        } else {
            setQuestions(currentQuestions)
        }
    }

    const editHandler = (editedQuestion, id) => {
        if (!editState.flag) {
            let currentQuestions = questions.map(question => question)
            currentQuestions[id] = editedQuestion
            setQuestions(currentQuestions)
            localStorage.setItem('questions', JSON.stringify(currentQuestions))
        }
        else {
            getQuestions()
        }
    }

    const saveHandler = () => {
        if (editState.flag) {
            if (!questionTemplateEmpty) {
                setAlertIsOpen(true)
            }
            else {
                dispatch(resetEdit())
                localStorage.removeItem('questions')
                localStorage.removeItem('quizId')
                dispatch(resetFormStatus())
                dispatch(resetQuestionFormStatus())
                history.push('/quizzes')
            }
        }
        else {
            if (!questionTemplateEmpty) {
                setAlertIsOpen(true)
            }
            else {
                let quizId = localStorage.getItem('quizId')
                let quizObject = {
                    quiz_id: quizId,
                    formData: questions
                }
                dispatch(submitQuestionAndChoices(quizObject))
            }
        }
    }

    const backClickHandlerInterceptor = () => {
        if (!questionTemplateEmpty) {
            setAlertIsOpen(true)
        }
        else {
            backClickHandler()
        }
    }

    useEffect(() => {
        if (formStatus.success && !formStatus.error) {
            if (!editState.flag) {
                toast({
                    title: "Quiz Questions Added!",
                    description: "Quiz Questions Added  Successfully!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
                localStorage.removeItem('questions')
                localStorage.removeItem('quizId')
                dispatch(resetFormStatus())
                dispatch(resetQuestionFormStatus())
                history.push('/quizzes')
            }
        }
        else if (formStatus.error) {
            toast({
                title: "Something went wrong!",
                description: formStatus.error,
                status: "error",
                duration: 3000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.success, formStatus.error, editState.flag])

    const getQuestions = () => {
        dispatch(loadQuizQuestions(editState.id))
    }

    useEffect(() => {
        if (editState.flag) {
            if (questionState.questions.length > 0 && !questionState.error) {
                setQuestions(questionState.questions)
                localStorage.setItem('questions', questionState.questions)
            }
        }
    }, [questionState.questions, questionState.error, editState.flag])

    useEffect(() => {
        if (editState.flag) {
            getQuestions()
        }
        else {
            let existingQuestions = localStorage.getItem('questions')
            setQuestions(existingQuestions ? JSON.parse(existingQuestions) : [])
        }
        // eslint-disable-next-line
    }, [editState.flag])

    useEffect(() => {
        const unblock = history.block((location, action) => {
            if (!questionTemplateEmpty) {
                setAlertIsOpen(true)
                return false;
            }
            return true;
        });

        return () => {
            dispatch(resetLoadedQuestions())
            localStorage.removeItem('questions')
            unblock();
        };
        // eslint-disable-next-line
    }, []);

    return (
        <Box
            style={{ gap: '1.5rem' }}
            d='flex'
            flexDir='column'
            width='100%'
            pointerEvents={formStatus.isSubmitting ? 'none' : 'all'}
        >
            {
                !editState.flag && <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='600'
                    fontSize={['10px', '12px', '14px']}
                    color='#666666'
                >
                    * Questions will be added to the database only on clicking Save & Publish.
                </Text>
            }
            {
                questionState.isLoading &&
                <Progress isIndeterminate size='xs' width='100%' />
            }

            {
                questions.length > 0 &&
                questions.map((question, idx) => <Question key={idx} id={idx} question={question.question} choices={question.choices} deleteHandler={deleteHandler} editHandler={editHandler} />)
            }

            <Box p='1.5rem' position='relative' width={['100%', '100%', '90%', '90%', '85%']} borderRadius='lg' bg='white' boxShadow='md' d='flex' flexDir='column' justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt='2rem'>
                {
                    editState.flag ? <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='600'
                        fontSize={['10px', '12px', '14px']}
                        color='#666666'
                    >
                        * Questions will be added to the database only on clicking Save Button.
                    </Text> : <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='600'
                        fontSize={['10px', '12px', '14px']}
                        color='#666666'
                    >
                        * Any question here will be lost if Save Button is not clicked
                    </Text>
                }
                <Input
                    variant='flushed'
                    focusBorderColor='none'
                    placeholder='Enter question here'
                    onChange={questionChangeHandler}
                    bg='white' style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize='16px'
                    ref={questionRef}
                />
                <RadioGroup
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize='16px'
                    onChange={setRadioButton}
                    value={radioButton || -1}
                    colorScheme='switch'
                >
                    <Stack direction="column" onMouseOut={() => setHoverPosition(null)}>
                        {
                            choices.map((choice, idx) => <Box
                                d='flex'
                                style={{ gap: '1rem' }}
                                key={idx}
                                justifyContent='flex-start'
                                alignItems='center'
                                onMouseOver={() => setHoverPosition(idx)}
                            >
                                <Radio value={choices[idx].choice.length ? choices[idx].choice : idx}></Radio>
                                <Input
                                    id={`text${idx}`}
                                    variant='flushed'
                                    width='40%'
                                    placeholder='Enter option here'
                                    bg='white'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontSize={['12px', '13px', '14px', '16px']}
                                    focusBorderColor='none'
                                    value={choices[idx].choice}
                                    onChange={(e) => {
                                        changeHandler(e, idx)
                                        setAddQuestionError(null)
                                    }}
                                />
                                <Box d='flex' flexGrow='1' opacity={hoverPosition === idx ? '1' : '0'} alignItems='center' transition='opacity 200ms ease'>
                                    <Circle size='18px' mr='2' cursor='pointer'>
                                        <MinusIcon fill='#666666' onClick={() => removeOptionHandler(idx)} />
                                    </Circle>
                                    <Circle size='18px' cursor='pointer'>
                                        <PlusIcon fill='#666666' onClick={() => addOptionHandler(idx)} />
                                    </Circle>
                                </Box>
                            </Box>
                            )
                        }
                    </Stack>
                </RadioGroup>
                <Button
                    bgColor='#70B259'
                    color='white'
                    borderRadius='lg'
                    p={['6px 15px', '8px 20px', '12px 30px']}
                    _hover={{ bg: "#64a04f" }}
                    loadingText='...Saving'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='800'
                    fontSize={['13px', '14px', '16px']}
                    position='absolute'
                    bottom={['-22.5%', '-22.5%', '-22.5%', '-22.5%', '0']}
                    border='2px solid #70B259'
                    right={['0', '0', '0', '0', '-20%']}
                    disabled={questionState.isLoading}
                    onClick={addQuestionHandler}
                    isLoading={isLoading}
                >
                    <><SaveIcon /> <Text ml='2'>Save</Text></>
                </Button>

            </Box>
            {
                addQuestionError && <Text style={{ fontFamily: 'Mulish, sans-serif' }} color='red.500' fontSize='sm'>{addQuestionError}</Text>
            }
            <Box width={['100%', '100%', '90%', '90%', '85%']} d='flex' flexDir={['column', 'column', 'row', 'row']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt={['4rem', '4rem', '3rem', '3rem', '2rem']}>
                <Button
                    bgColor='#70B259'
                    color='white'
                    borderRadius='lg'
                    p={['6px 15px', '8px 20px', '12px 30px']}
                    _hover={{ bg: "#64a04f" }}
                    loadingText={editState.flag ? 'Redirecting...' : 'Saving...'}
                    isLoading={questionState.isLoading || formStatus.isSubmitting}
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='800'
                    fontSize={['13px', '14px', '16px']}
                    mr={['0', '0', '20px', '20px']}
                    mb={['20px', '20px', '0', '0']}
                    disabled={questions.length === 0}
                    onClick={saveHandler}
                >
                    {editState.flag ? 'Done' : 'Save & Publish'}
                </Button>

                {
                    !editState.flag &&
                    <Button
                        bgColor='white'
                        color='#70b259'
                        borderRadius='lg'
                        p={['6px 15px', '8px 20px', '12px 30px']}
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='800'
                        fontSize={['13px', '14px', '16px']}
                        onClick={backClickHandlerInterceptor}
                        border='2px solid #70B259'
                        disabled={questionState.isLoading || formStatus.isSubmitting}

                    >
                        Back
                    </Button>
                }
            </Box>
            <AlertMessage isOpen={alertIsOpen} onClose={() => setAlertIsOpen(false)} text={'Warning!'} message={'You have unsaved questions!'} />
        </Box>
    )
}